export function register_translate_loan_purpose(Survey) {
  Survey.FunctionFactory.Instance.register("translateLoanPurpose", (params) => {
    const purpose = params[0];
    const translations = {
      'coffee': 'ikawa',
      'maize': 'ibigori', 
      'beans': 'ibishyimbo',
      'orange_sweet_potato': 'ibijumba by\'umutuku',
      'tea': 'icyayi',
      'potatoes': 'ibirayi',
      'chili': 'urusenda',
      'carrots': 'karoti',
      'avocado': 'avoka',
      'passion_fruit': 'marakuja',
      'fish': 'ifi',
      'tomato': 'inyanya',
      'onion': 'ibitunguru'
    };
    return translations[purpose] || purpose;
  });
}

const terms_and_conditions = {
  title: {
    en: "Terms and conditions",
    rw: "Amategeko n'amabwiriza",
  },
  name: "loan",
  elements: [
    {
      name: "insurance",
      type: "panel",
      innerIndent: 1,
      elements: [
        {
          type: "html",
          visibleIf: "{loan_purpose} == 'onion' or {loan_purpose} == 'avocado' or {loan_purpose} == 'tomato' or {loan_purpose} == 'fish' or {loan_purpose} == 'passion_fruit'",
          html: {
              en: `<h3>Introduction</h3><br>
                  The Kwihaza Interest Rate Subsidy (IRS) Scheme is a strategic initiative led by Access to Finance Rwanda (AFR) aimed at enhancing access to affordable finance 
                  for actors in selected agricultural value chains. Through targeted interest rate subsidies, the scheme addresses high borrowing costs that constrain productivity and 
                  investment, particularly for smallholder farmers, cooperatives, and agri-MSMEs. `,
              rw: `<h3>Intangiriro</h3><br>
                  Gahunda ya Kwihaza Inkunga ku Rugero rw'Inguzanyo (IRS) ni gahunda y'ingamba iyobowe na Access to Finance Rwanda (AFR) igamije kunoza uburyo bwo kubona inguzanyo 
                  ihendutse ku bakora mu buhinzi bwatoranyijwe. Binyuze ku nyungu igabanyije ku nguzanyo, iyi gahunda izakemura ikiguzi kinini ku nguzanyo kibangamira umusaruro n'ishoramari, 
                  cyane cyane ku bahinzi bato, amakoperative, n'ibigo bito n'ibiciriritse bikora  mu buhinzi.`
          }
        },
        {
          type: "html",
          title: "",
          visibleIf: "{loan_purpose} != 'onion' and {loan_purpose} != 'avocado' and {loan_purpose} != 'tomato' and {loan_purpose} != 'fish' and {loan_purpose} != 'passion_fruit'",
          html: {
            en: `I, the undersigned, hereby declare the validity and accuracy of the above-mentioned information, data and
                  documents provided by me to MoneyPhone Africa Ltd., the Lender, and that they are identical to my personal
                  information and have been filled out by me personally with my full legal capacity, my freedom and my will.`,
            rw: `Njyewe, nemeje ko amakuru nahaye MoneyPhone Africa Ltd ko ari ukuri , kandi ko ntanze amakuru yanjye bwite
                  kandi yujujwe nanjye mu mudendezo no kubushake bwanjye  mu uburyo bwemewe n'amategeko.`,
          },
        },
        {
          type: "html",
          visibleIf: "{loan_purpose} == 'onion' or {loan_purpose} == 'avocado' or {loan_purpose} == 'tomato' or {loan_purpose} == 'fish' or {loan_purpose} == 'passion_fruit'",
          html: {
            en: `<h3>Terms and Conditions</h3><br>
                  I, the undersigned, hereby declare the validity and accuracy of the above-mentioned 
                  information, data, and documents provided by me to MoneyPhone Africa Ltd., the Lender, 
                  and confirm that they correspond to my personal and business information, have been provided by me personally, and are submitted with full legal capacity, 
                  freely and voluntarily. `,
            rw: `<h3>Amategeko n'amabwiriza</h3><br>
                  Jyewe ,washyizeho umukono, ndemeza ko amakuru, inyandiko nahaye MoneyPhone Africa Ltd, Uguriza, ko ari ukuri kandi zihuye cg zerekana imyirondoro yanjye n’iy’ubucuruzi
                  zikaba zatanzwe nanjye  kandi ku bushake bwanjye, nta gahato.`,
          },
        },
        {
          type: "html", 
          visibleIf: "{loan_purpose} == 'onion' or {loan_purpose} == 'avocado' or {loan_purpose} == 'tomato' or {loan_purpose} == 'fish' or {loan_purpose} == 'passion_fruit'",
          html: {
            en: `I {first_name} {last_name}, confirm that I have applied for a loan amount of {amount} RWF at an annual market interest rate of 20% with an annual subsidized 
                  rate of 8%  from AFR and 2% annual subsidy of MoneyPhone for a period of 0.5 years. `,
            rw: `Jye {first_name} {last_name} ndemeza kandi ko nasabye inguzanyo ya RWF {amount} ku nyungu ya 20% ku mwaka hamwe n’ikigeranyo cy’inyungu
                 cya 8% y’inkunga ya AFR hamwe n’ikigeranyo cy’inyungu  2% y’inkunga ya MoneyPhone ku mwaka mu gihe cy'amezi atandatu (6). `,
          },
        },
        {
          type: "html",
          visibleIf: "{loan_purpose} == 'onion' or {loan_purpose} == 'avocado' or {loan_purpose} == 'tomato' or {loan_purpose} == 'fish' or {loan_purpose} == 'passion_fruit'",
          html: {
            en: `I, the undersigned, declare that I have no objection to the Lender inquiring, viewing, providing, and/or exchanging credit information and 
                  other relevant information about me with credit information companies, the Central Bank, Access to Finance Rwanda (AFR), AFR funders, and 
                  other legally authorized parties, for purposes of loan assessment, administration, implementation of interest rate subsidies, monitoring, 
                  reporting, and compliance. I acknowledge the right of the Lender to request additional information and/or documents at any time. `,
            rw: `Jyewe, uwasinye, ndemeza ko nta kibazo mfite ku bijyanye n’uko Utanga inguzanyo yabaza, yureba, yatanga, cyangwa yhanahana amakuru y’inguzanyo
                 n’andi makuru ajyanye nanjye n’ibigo bitanga amakuru ku nguzanyo, Banki Nkuru y’igihugu, Access to Finance Rwanda (AFR), abaterankunga ba AFR, 
                 n’abandi bantu bemewe n’amategeko, mu rwego rwo gusuzuma inguzanyo, kuyobora, gushyira mu bikorwa inkunga ku nyungu, gukurikirana, gutanga raporo,
                 no kubahiriza amategeko. Ndemera  ko nzi uburenganzira bw’Utanga inguzanyo bwo gusaba andi makuru cyangwa inyandiko igihe cyose biri ngombwa.`,
          },
        },
        {
          type: "html",
          visibleIf: "{loan_purpose} == 'onion' or {loan_purpose} == 'avocado' or {loan_purpose} == 'tomato' or {loan_purpose} == 'fish' or {loan_purpose} == 'passion_fruit'",
          html: {
            en: `I acknowledge that I am fully aware of all administrative and legal consequences of failure to repay the loan on time. `,
            rw: `Ndemera ko nzi neza ingaruka zose zo mur rwego rw’ubuyobozi n’iz’amategeko zo kutishyura inguzanyo ku gihe.`,
          },
        },
        {
          type: "html",
          visibleIf: "{loan_purpose} == 'onion' or {loan_purpose} == 'avocado' or {loan_purpose} == 'tomato' or {loan_purpose} == 'fish' or {loan_purpose} == 'passion_fruit'",
          html: {
            en: `I declare that I have inquired into and fully understand all financing conditions, interest rates, prices, administrative expenses, and terms and
                  conditions applicable to the loan, including where applicable the application of an interest rate subsidy under the Kwihaza Interest Rate Subsidy (IRS) 
                  Scheme implemented by Access to Finance Rwanda (AFR). `,
            rw: `Ndemeza ko nabajije kandi nsobanukiwe neza ibisabwa byose mu bijyanye n’imari, inyungu, ibiciro, amafaranga yo mu rwego rw’ubuyobozi, n’amahame n’amabwiriza 
                 agenga inguzanyo, harimo no gusaba inkunga ku nyungu muri gahunda y’inkunga ya Kwihaza ku nyungu igabanyije (IRS) ishyirwa mu bikorwa na Access to Finance Rwanda (AFR).`,
          },
        },
        {
          type: "html",
          visibleIf: "{loan_purpose} == 'onion' or {loan_purpose} == 'avocado' or {loan_purpose} == 'tomato' or {loan_purpose} == 'fish' or {loan_purpose} == 'passion_fruit'",
          html: {
            en: `I declare that all copies of documents uploaded through the website or electronic application are true copies and that all data provided by me is accurate and
                 provided under my responsibility. `,
            rw: `Ndemeza ko kopi zose z’inyandiko zashyizwe ku rubuga cyangwa porogaramu y’ikoranabuhanga isabirwaho inguzanyo ari kopi nyazo kandi ko amakuru yose natanze ari
                 ukuri kandi atangwa ku bushake bwanjye zanjye.`,
          },
        },
        {
          type: "html",
          visibleIf: "{loan_purpose} == 'onion' or {loan_purpose} == 'avocado' or {loan_purpose} == 'tomato' or {loan_purpose} == 'fish' or {loan_purpose} == 'passion_fruit'",
          html: {
            en: `I acknowledge that I have read and agreed to the terms, conditions, and privacy policy provided by the Lender, MoneyPhone Africa Ltd. `,
            rw: `Ndemera ko nasomye kandi nemeranya n’amategeko n'amabwiriza,  hamwe na gahunda y’amakuru y’ubuzima bwite yatanzwe n'utanga inguzanyo, ariwe MoneyPhone Africa Ltd.`,
          },
        },
        {
          type: "html",
          visibleIf: "{loan_purpose} == 'onion' or {loan_purpose} == 'avocado' or {loan_purpose} == 'tomato' or {loan_purpose} == 'fish' or {loan_purpose} == 'passion_fruit'",
          html: {
            en: `I further acknowledge that where my loan benefits from the Kwihaza Interest Rate Subsidy (IRS) Scheme, the loan is provided at a market interest rate 
                  with a subsidy applied in accordance with the Scheme’s rules. `,
            rw: `Nongeye kwemera kandi ko  inguzanyo yanjye yungukira muri gahunda y’inyungu igabanjye ya Kwihaza Inyungu (IRS), inguzanyo yanjye yatanzwe ku nyungu 
                 cg ku giciro kuri ku isoko ikaba ihabwa inkunga hakurikijwe amategeko n’amabwiriza bya gahunda ya Kwihaza. `,
          },
        },
        {
          type: "html",
          visibleIf: "{loan_purpose} == 'onion' or {loan_purpose} == 'avocado' or {loan_purpose} == 'tomato' or {loan_purpose} == 'fish' or {loan_purpose} == 'passion_fruit'",
          html: {
            en: `I hereby consent to the collection, processing, use, storage, and sharing of my personal and business information by MoneyPhone Africa Ltd., 
                  Access to Finance Rwanda (AFR), and AFR funders, solely for purposes related to the Kwihaza IRS Scheme, including verification of eligibility and 
                  compliance, administration of the subsidy, monitoring and evaluation of outcomes and impact, reporting, surveys, learning products, publications, 
                  and ensuring compliance with applicable environmental and social standards. `,
            rw: `Ndemera kandi ko amakuru yanjye bwite n'ay'ubucuruzi akusanywa, akoreshwa abikwa, ahererekanywa na MoneyPhone Africa Ltd., Access to Finance Rwanda (AFR),
                 n'abaterankunga ba AFR, muri gahunda za  Kwihaza gusa, harimo no kugenzura  ibisabwa, kubahiriza, gucunga inkunga, gukurikirana no gusuzuma ibyavuye mu 
                 bushakashatsi n'ingaruka, gutanga raporo, ubushakashatsi, kwiga ibicuruzwa, gutangaza, no kugenzura ko amahame agenga ibidukikije n'imibereho myiza yubahirizwa.`,
          },
        },
        {
          type: "html",
          visibleIf: "{loan_purpose} == 'onion' or {loan_purpose} == 'avocado' or {loan_purpose} == 'tomato' or {loan_purpose} == 'fish' or {loan_purpose} == 'passion_fruit'",
          html: {
            en: `I understand that data processed for these purposes may include identification and contact details, loan and repayment information, business or 
                  agricultural activity information, and other relevant financial, operational, environmental, or social data required for implementation and reporting. `,
            rw: `Ndumva ko amakuru atunganywa muri izi mpamvu  ashobora kuba arimo amakuru yerekeye imyirondoro cg amakuru ya telefoni, amakuru yerekeye inguzanyo no kwishyura, 
                 amakuru y'ibikorwa by'ubucuruzi cyangwa ubuhinzi, n'andi makuru y'imari, imikorere, ibidukikije, cyangwa imibereho akenewe kugira mu gushyira mu bikorwa cyangwa
                 no gutanga raporo.`,
          },
        },
        {
          type: "html",
          visibleIf: "{loan_purpose} == 'onion' or {loan_purpose} == 'avocado' or {loan_purpose} == 'tomato' or {loan_purpose} == 'fish' or {loan_purpose} == 'passion_fruit'",
          html: {
            en: `I acknowledge that my data may be securely stored and processed, and aggregated or anonymized for reporting and 
                  learning purposes. Identifiable information will only be published externally with my explicit consent. `,
            rw: `Ndemera ko amakuru yanjye ashobora kubikwa neza kandi agatunganywa, agashyirwa hamwe cyangwa agashyirwa ku mugaragaro mu gutanga raporo cywangwa kwiga.
                 Amakuru azwi azatangazwa gusa hanze ari uko nabitangiye uburenganizira.`,
          },
        },
        {
          type: "html",
          visibleIf: "{loan_purpose} == 'onion' or {loan_purpose} == 'avocado' or {loan_purpose} == 'tomato' or {loan_purpose} == 'fish' or {loan_purpose} == 'passion_fruit'",
          html: {
            en: `I acknowledge that I have the right to access, correct, or request deletion of my personal data in accordance with applicable data protection laws, 
                  and that I may withdraw my consent at any time by contacting AFR’s Data Protection Officer at dataprotection@afr.rw. Withdrawal of consent will apply 
                  to future processing and will not affect lawful processing already undertaken. `,
            rw: `Ndemera ko mfite uburenganzira bwo kubona, gukosora, cyangwa gusaba gusiba amakuru yanjye bwite hakurikijwe amategeko agenga kurengera amakuru,
                 kandi ko nshobora gukuraho uburenganzira natanze  igihe ari uko mvuganye n'ushinzwe kurengera amakuru kigo cya AFR kuri dataprotection@afr.rw.
                 Gukuraho uburenganzira bireba  ibyakorwa mu gihe kizaza,  kandi ntibizagira ingaruka ku byakozwe cyera.`,
          },
        },
           {
          type: "html",
          visibleIf: "{loan_purpose} == 'onion' or {loan_purpose} == 'avocado' or {loan_purpose} == 'tomato' or {loan_purpose} == 'fish' or {loan_purpose} == 'passion_fruit'",
          html: {
            en: `By accepting these Terms and Conditions electronically, I confirm that I have read, understood, and consent to the above. `,
            rw: `Nemeye aya mabwiriza n'Amategeko mu buryo bw'ikoranabuhanga, kandi ndemeza ko nasomye, nasobanukiwe, kandi nemera ibyavuzwe haruguru.`,
          },
        },
        {
          type: "html",
          visibleIf: "{loan_purpose} != 'onion' and {loan_purpose} != 'avocado' and {loan_purpose} != 'tomato' and {loan_purpose} != 'fish' and {loan_purpose} != 'passion_fruit'",
          html: {
            en: `I have no objection to the Lender verifying all the data submitted by me or by any party that the Lender
                  seems appropriate.`,
          },
        },
        {
          type: "html",
          visibleIf: "{loan_purpose} != 'tea' and {loan_purpose} != 'coffee' and {loan_purpose} != 'onion' and {loan_purpose} != 'avocado' and {loan_purpose} != 'tomato' and {loan_purpose} != 'fish' and {loan_purpose} != 'passion_fruit'",
          html: {
            en: `I, the undersigned, declare that I have no objection to Lender inquiring and/or viewing and/or providing
                  and/or exchanging credit information and/or other information about me with credit information companies,
                  and the exchange of any of the information provided by me and any other relevant data with the Central
                  Bank, BRD and/or any other related parties as of its date without the Lender bearing any legal responsibility
                  for that, and I acknowledge the right The Lender may request any additional information and/or documents
                  at any time, or review one of its branches if necessary. I also acknowledge that I made the inquiry and
                  that I am fully aware of all the administrative and legal aspects of failure to pay on time.`,
            rw: `Nemeye kandi ndumva neza ko nta nzitizi mfite ko MoneyPhone yagenzura cyangwa yabaza/yatanga amakuru ku nguzanyo yanjye ku bigo bishinzwe kugenzura inguzanyo ndetse na bank nkuru y'igihugu cyangwa bank itsura amajyambere (BRD), Nemeye ko MoneyPhone yansaba andi makuru yose ajyanye n'ubusabe bw'inguzanyo yanjye igihe ari cyose iyakeneye. 
            Ndemera kandi nzi neza ibijyanye n'amabwiriza n'amategeko byose bijyanye no kutishyurira ku gihe inguzanyo nsabye.`,
          },
        },
        {
          type: "html",
          visibleIf: "{loan_purpose} == 'tea' or {loan_purpose} == 'coffee'",
          html: {
            en: `I, the undersigned, declare that I have no objection to Lender inquiring and/or viewing and/or providing 
                  and/or exchanging credit information and/or other information about me with credit information companies,
                  and the exchange of any of the information provided by me and any other relevant data with the Central 
                  Bank and/or any other related parties as of its  date without the Lender bearing any legal responsibility
                  for that, and I acknowledge the right The Lender may request any additional information and/or documents 
                  at any time, or review one of its branches if necessary. I also acknowledge that I made the inquiry and
                  that I am fully aware of all the administrative and legal aspects of failure to pay on time.`,
            rw: `Nemeye kandi ndumva neza ko nta nzitizi mfite ko MoneyPhone yagenzura cyangwa yabaza/yatanga amakuru ku nguzanyo yanjye ku bigo bishinzwe kugenzura inguzanyo ndetse na bank nkuru y'igihugu, Nemeye ko MoneyPhone yansaba andi makuru yose ajyanye n'ubusabe bw'inguzanyo yanjye igihe ari cyose iyakeneye. 
            Ndemera kandi nzi neza ibijyanye n'amabwiriza n'amategeko byose bijyanye no kutishyurira ku gihe inguzanyo nsabye.`,
          },
        },
        {
          type: "html",
          visibleIf: "{loan_purpose} != 'onion' and {loan_purpose} != 'avocado' and {loan_purpose} != 'tomato' and {loan_purpose} != 'fish' and {loan_purpose} != 'passion_fruit'",
          html: {
            en: `I also declare that I have inquired and that I am fully aware of all financing conditions, prices,
                  administrative expenses, terms and conditions of use.`,
            rw: `Ndemeza ko nabajije kandi nzi neza  ibiciro byose by'iyi nguzanyo, umufuragiro, inyungu k'unguzanyo
                  nandi mabwiriza yo gukoresha iyi nguzanyo`,
          },
        },
        {
          type: "html",
          visibleIf: "{loan_purpose} != 'onion' and {loan_purpose} != 'avocado' and {loan_purpose} != 'tomato' and {loan_purpose} != 'fish' and {loan_purpose} != 'passion_fruit'",
          html: {
            en: `I declare that all copies of the attached documents that have been attached to the website/electronic
                  application are true copies and that all edited data are written by me, correct and under my responsibility.`,
            rw: `Ndemeza ko kopi zose zinyandiko nometse kurubuga  rwa MoneyPhone ari kopi zukuri kandi ko amakuru yose
                  yahinduwe yanditswe nanjye kandi ari ukuri`,
          },
        },
        {
          type: "html",
          visibleIf: "{loan_purpose} != 'onion' and {loan_purpose} != 'avocado' and {loan_purpose} != 'tomato' and {loan_purpose} != 'fish' and {loan_purpose} != 'passion_fruit'",
          html: {
            en: `I acknowledge that I have read and agreed to the terms, conditions and privacy policy provided to me
                  by the Lender, MoneyPhone Africa Ltd.`,
            rw: "Nemeye ko nasomye kandi nemera amabwiriza y'iyinguzanyo MoneyPhone Africa Ltd impaye.",
          },
        },
        {
          type: "html",
          html: {
            en: `<h3>Environmental and Social Responsibility</h3><br>
              The Borrower commits to conduct all activities in compliance with applicable environmental and social standards, 
              and shall not engage in practices that cause harm to the environment, community health, safety, or social well-being.`,
            rw: `<h3>Inshingano ku muryango mugari n'ibidukikije</h3><br>
              Uwagurijwe yiyemeje gukora ibikorwa byose yubahiriza ibipimo n'amabwiriza ngenderwaho by'ibidukikije n'imibereho myiza kandi
              ntashobora gukora ibikorwa byangiza ibidukikije, ubuzima bw’abaturage, umutekano, cyangwa imibereho myiza y'abaturage.`,
          },
        },
        {
              type: "html",
              visibleIf: "{loan_type} == 'group'",
              html: {
                  en: `<h3>Guarantor obligations</h3><br>
                I hereby acknowledge and agree to act as a joint and several guarantor together with the other four individuals participating in this loan application. I expressly undertake to guarantee the due and punctual repayment of each individual borrower’s obligations within the group.<br><br>
                In the event that any co-borrower fails to fulfil their repayment obligations in whole or in part, I shall, upon demand by the Lender, be jointly and severally liable for such outstanding amounts and shall make payment on their behalf without delay.<br><br>
                I further acknowledge that this loan constitutes a joint financial undertaking, and that the loan shall be deemed fully repaid only when all individual loan obligations within the group have been satisfied in full.`,
                  rw: `<h3>Inshingano z'umwishingizi</h3><br>
                Njyewe, niyemeje kandi nemeye gukora nk'umwishingizi w’umwe cg benshi mu bantu bane twafatanyije mu gusaba inguzanyo muri iri tsinda. Niyemeje byimazeyo kwemeza ko ubwishyu bukwiye buzajya butangwa kandi bwubahirije igihe kuri buri munyamurwango w’iri tsinda wagurijwe.<br><br>
                Mugihe mugenzi wanjye wagurijwe wese adashoboye kubahiriza inshingano zo kwishyura zose cyangwa yazubahirije by’igice, kandi mbisabwe n’uwaduhaye inguzanyo, nzabazwa ayo mafaranga ya bagenzi banjye kandi nkayishyura mw’izina ryabo kandi bidatinze.<br><br>
                Nongeye kandi kwemeza ko iyi nguzanyo ari inguzanyo ihuriweho, kandi ko iyo inguzanyo izafatwa nk’aho yishyuwe byuzuye mugihe ubwishyu bwose bwa buri munyamurango w’itsinda bwatanzwe uko bwakabaye.`
              }
        },
        {
          title: " ",
          type: "checkbox",
          name: "agreeMicroInsuranceProgramms",
          isRequired: true,
          choices: [
            {
              value:
                "Applicant has agreed to micro insurance programs in the review flow.",
              text: {
                en: "I agree",
                rw: "Ndabyemeye",
              },
            },
          ],
          validators: [],
        },
      ],
    },
  ],
}

const date = {
  type: "expression",
  name: "today_date",
  expression: "daysFromNow(0, 0, 'rw')",
  title: { en: "Date", rw: "Italiki" },
}

const total_overview = {
  name: "total_overview",
  type: "panel",
  visibleIf: "{amount} notempty and {repayment_period} notempty",
  elements: [
    {
      type: "html",
      html: {
        en: "Between:",
        rw: "Hagati : ",
      },
    },
    {
      type: "html",
      html: {
        en: `MoneyPhone Africa LTD, residing in Rwanda and represented by Jean Paul Mushumba, hereinafter
              referred to as the "Lender,"`,
        rw: `MoneyPhone Africa LTD, ikigo cy'ubucuruzi gitanga inguzanyo kibarizwa mu Rwanda kikaba
              gihagarariwe na Jean Paul Mushumba, akaba ariwe uguriza.`,
      },
    },
    {
      type: "html",
      html: {
        en: "and",
        rw: "na",
      },
    },
    {
      type: "html",
      html: {
        en: `{first_name} {last_name}, {applicant_id} with phone number {phone_number} residing at {province}, {district}, {home_country}, {cell}, {village}
              hereinafter referred to as the "Borrower".`,
        rw: `Na {first_name} {last_name}, {applicant_id} na numero ya telephone {phone_number} utuye {province}, {district}, {home_country}, {cell}, {village}
              hano uvugwa nk'Uguza.`,
      },
    },
    {
      type: "html",
      visibleIf: "{intake.custom_text_7} == 'yes'",
      html: {
        en: 'With bank account No. {bank_account}, bank name {bank_name}',
        rw: "Ufite Konti ya Banki Nomero {bank_account} ibarizwa muri banki {bank_name}",
      },
    },
    {
      type: "html",
      visibleIf: "{intake.custom_text_5} == 'yes'",
      html: {
        en: "With mobile wallet {mobile}, with phone number {phone_number}",
        rw: "Na Konti ya MOMO yanditswe kuri {mobile} ufite nomero ya tel {phone_number}",
      },
    },
    {
      type: "html",
      html: {
        en: "All parties agree to enter into the following loan agreement, subject to the following terms and conditions:",
        rw: "Impande zombi zemeranyijwe kugirana amasezerano yinguzanyo, hashingiwe ku ngingo zikurikira:",
      },
    },
  ],
}

// This is used by all crops except Tea
const loan_terms = {
  name: "loan_terms_panel",
  type: "panel",
  title: {
    en: "Loan Terms",
    rw: "Ingingo zigize aya masezerano y'inguzanyo",
  },
  description: {
    en: "The borrower is committing to pay the lender the amount borrowed in accordance with the following:",
    rw: "Ugurizwa yiyemeje kwishyura uwamugurije umwenda akurikije ibi bikurikira:",
  },
  visibleIf: "{amount} notempty and {repayment_period} notempty",
  elements: [
    {
      name: "loan_terms",
      valueName: "loan_terms",
      type: "expression",
      expression:
        "loan_terms", // Floating Point Proof
      title: "Technical loan terms (NOT visible for user)",
      visibleIf: "{amount} < 0",
    },
    {
      title: {
        en: "Requested loan amount in RWF",
        rw: "Amafaranga y'inguzanyo asabwa",
      },
      type: "expression",
      expression: "{requested_amount}",
    },
    {
      title: {
        en: "Approved loan amount in RWF",
        rw: "Amafaranga y'inguzanyo yemejwe",
      },
      type: "expression",
      expression: "{amount}", // Floating Point Proof
    },
    {
      title: {
        en: "Loan term (in months)",
        rw: "Igihe inguzanyo izamara (Mu mezi)",
      },
      name: "repayment_period",
      type: "expression",
      expression: "{repayment_period}", // Floating Point Proof
    },
    {
      title: {
        en: "Total administrative fees in RWF to be deducted from the loan amount ({admin_fee})",
        rw: "Amafaranga ya serivise y'ubuyobozi angana na {admin_fee} akurwa kunguzanyo yemejwe",
      },
      type: "expression",
      expression: "{charge_dict.charge_code_1.total}", // Floating Point Proof
    },
    {
      title: {
        en: "Total VAT on administrative fees in RWF to be deducted from the loan amount ({vat_on_admin_fee})",
        rw: "Umusoro(VAT) ukurwa kunguzanyo yemejwe ({vat_on_admin_fee})",
      },
      type: "expression",
      expression: "{charge_dict.charge_code_2.total}", // Floating Point Proof
    },
    {
      title: {
        en: "Insurance fees in RWF to be deducted from the loan amount ({insurance_fee}) ",
        rw: "Amafaranga y'ubwishingizi akurwa kunguzanyo yemejwe ({insurance_fee})",
      },
      type: "expression",
      expression: "{charge_dict.charge_code_3.total}", // Floating Point Proof
    },
    {
      title: {
        en: "Loan interest in RWF ({product_interest_rate}% per year)",
        rw: "Inyungu ku ngunzanyo mu mwaka mu RWF ({product_interest_rate}% ku mwaka)",
      },
      name: "custom_float_5",
      type: "expression",
      expression: "{total_interest}", // Floating Point Proof
    },
    {
      title: {
        en: "Total loan amount to be disbursed: approved loan amount minus fees",
        rw: "Igiteranyo cy'Amafaranga yinguzanyo yemejwe gutangwa",
      },
      name: "custom_float_6",
      type: "expression",
      expression: "fixed(subtract({amount},{charge_dict.charge_code_1.total},{charge_dict.charge_code_2.total},{charge_dict.charge_code_3.total})", // Floating Point Proof
    },
    {
      title: {
        en: "Total loan amount to be repaid: approved loan amount plus interest",
        rw: "Igiteranyo cy' Amafaranga yinguzanyo yemejwe gusubizwa",
      },
      name: "custom_float_7",
      type: "expression",
      expression: "fixed(add({amount}, {total_interest}))", // Floating Point Proof
    },
    {
      title: {
        en: "Annual Percentage Rate (APR) %",
        rw: "Ijanisha ry'inguzanyo ku mwaka %",
      },
      type: "expression",
      expression: "fixed({annual_percentage_rate}", // Floating Point Proof
    },
    {
      title: {
        en: "Cooking Stove",
        rw: "Imbabura ya kijyambere"
      },
      name: "cooking_stove_amount",
      type: "expression",
      visibleIf: "{intake.custom_bool_3} = true",
      expression: "{intake.cooking_stove_amount}"
    },
    {
      visibleIf: "{intake.custom_bool_3} = true",
      type: "panel",
      title: {
        en: "Cooking Stove",
        rw: "Imbabura ya kijyambere",
      },
      elements: [
        {
          type: "html",
          html: {
             en: `By selecting the option to include a cooking stove in the loan application, an amount of RWF {cooking_stove_amount} will be deducted from the amount disbursed allocated for the cooking stove. The farmer acknowledges that this amount is non-refundable and will be directly allocated for the purchase of the cooking stove as part of the loan agreement.`,
            rw: `Mu guhitamo uburyo bwo guhabwa imbabura ya kijyambere mu busabe bw'inguzanyo, igiciro cya {cooking_stove_amount}rwf kirakurwa ku mafaranga y'inguzanyo agenerwe imbabura ya kijyambere . Umuhinzi aremeza ko aya mafaranga adasubizwa kandi ko azaba ajyenewe mu kugura imbabura ya kijyambere nka kimwe mu bikubiye mu masezerano y'inguzanyo.`,
          },
        },
      ],
    },
  ],
}

const guarantee = {
  name: "guarantee",
  type: "panel",
  title: {
    en: "Guarantee",
    rw: "Umwishingizi",
  },
  elements: [
    {
      type: "html",
      visibleIf: "{loan_purpose}!='avocado'",
      html: {
        en: `The Borrower provides {cooperative_name} as guarantee for the loan. Additionally, the Cooperative acts
              as a guarantor for the fulfillment of the Borrower's obligations and guarantees its member, who is the
              applicant for this loan.`,
        rw: `Ugurizwa atanze {cooperative_name} nk’Umwishingizi y'inguzanyo. Byongeye kandi, Koperative ihinduka kuba Umwishingizi
              yo kuzuza inshingano z'uwagurijwe kandi ikanishingira umunyamuryango wayo, usaba iyi nguzanyo.`,
      },
    },
    {
      type: "html",
      visibleIf: "{loan_purpose}=='avocado'",
      html: {
        en: `The Borrower provides {cooperative_name} as guarantee for the loan. Additionally, the Association acts
              as a guarantor for the fulfillment of the Borrower's obligations and guarantees its member, who is the
              applicant for this loan.`,
        rw: `Ugurizwa atanze {cooperative_name} nk'umwishingizi w'inguzanyo. Byongeye kandi, ishyirahamwe rihinduka
              umwishingizi kubyo ugurizwa asabwa byose nk'umunyamuryango waryo, ariwe usaba iyi nguzanyo`,
      },
    },
    {
      type: "html",
      visibleIf: "{loan_purpose}!='avocado'",
      html: {
        en: `The cooperative agrees to pay on behalf of the borrower in the event that he or she becomes insolvent. The
              cooperative will pay all debts owed to the Lender by the cooperative member.`,
        rw: `Koperative yemeye kwishyura mu izina ry'uwagurijwe mu gihe ananiwe kwishyura umwenda. Koperative izishyura
              umwenda wose Umunyamuryango abereyemo uguriza w'inguzanyo.`,
      },
    },
    {
      type: "html",
      visibleIf: "{loan_purpose}=='avocado'",
      html: {
        en: `The Association agrees to pay on behalf of the borrower in the event that he or she becomes insolvent. The
              Association will pay all debts owed to the Lender by the cooperative member.`,
        rw: `Ishyirahamwe ryemeye kwishyurira ugurizwa mu gihe ananiwe kwishyura neza.
              Ishyirahamwe rizishyura inguzanyo yose umunyamuryango waryo azaba afitiye uguriza.`,
      },
    },
  ],
}

const guarantee_irrigation_system = {
    name: "guarantee_irrigation_system",
    type: "panel",
    title: {
        en: "Guarantee",
        rw: "Ubwishingirane ",
    },
    elements: [
        {
            type: "html",
            html: {
                en: `The Borrower enters into a joint guarantor arrangement together with the other four individuals participating in the purchase of the irrigation system. 
                Each individual borrower shall act as a joint and several guarantor for the repayment obligations of the others under their respective loan agreements. 
                In the event that any borrower defaults on their repayment obligations, the remaining borrowers shall, upon demand by the Lender, be jointly and 
                severally liable for the outstanding debt of the defaulting borrower and shall repay such amount on their behalf. 
                In consideration of this mutual arrangement, each of the other individuals likewise agrees to act as a joint and several guarantor for
                 the Borrower’s obligations under this loan.`,
                rw: `Uwagurijwe yinjira mu buryo bwo kwishingirana buhuriweho n'abandi bantu bane bitabiriye kugura uburyo bwo kuhira imyaka. Buri muntu wagurijwe ku giti cye agomba kuba umwishingizi w’abandi bahuriye mu itsinda muri aya masezerano y’inguzanyo kandi akishingira ko abandi bari kumwe bazishyura neza amafaranga bagurijwe. 
                Mu gihe uwagurijwe wese atubahirije inshingano ze zo kwishyura umwenda, abahawe inguzanyo basigaye, babisabwe n’uwatanze inguzanyo, barafatanya bose bakaryozwa cg bakishyura umwenda wa bagenzi babo bananiwe kwishyura kandi bakabikora mu izina ry’abananiwe kwishyura. 
                Miri iyi gahunda, buri muntu ku giti cye na we yemeye gukora nk'ingwate cg umwishingizi wa mugenzi we ku nshingano zo kwishyura  iyi nguzanyo. `,
            }
        }
    ]

}

const mobile_wallet_payments = {
  name: "mobile_wallet_payments",
  type: "panel",
  title: {
    en: "Mobile Wallet Payments",
    rw: "Kwishyura",
  },
  elements: [
    {
      type: "html",
      html: {
        en: `Borrowers must provide an accurate and up-to-date phone number for mobile wallet
              disbursements. MoneyPhone Africa is not responsible for funds sent to incorrect
              or outdated numbers provided by the Borrower. Verification of the phone number
              before disbursement is required to ensure accuracy.`,
        rw: `Abakira inguzanyo bakoresheje Mobile Money (Momo) bagomba gutanga nimero ya telefone
              nyayo kandi basanzwe bakoresha kugira ngo babashe kwakira amafaranga. MoneyPhone
              Africa ntizishingira amafaranga yoherejwe kuri nimero ya telefone itariyo cyangwa
              idakoreshwa yatanzwe n'usaba inguzanyo. Mbere yo kohereza amafaranga, kugenzura
              nimero ya telefone birakenewe kugira ngo hirindwe amakosa.`,
      },
    },
  ],
}

const use_of_loan = {
  name: "use_of_loan",
  type: "panel",
  title: {
    en: "Use of the Loan",
    rw: "Icyo inguzanyo izakoreshwa",
  },
  elements: [
    {
      type: "html",
      html: {
        en: `The Borrower agrees to use the loan funds exclusively for farming-related activities,
              including production and post-harvest processes. Specifically, the loan will be used 
              to finance the cultivation and management of {loan_purpose}.`,
        rw: `Usaba inguzanyo yemera gukoresha inguzanyo mu bikorwa by'ubuhinzi gusa,
              harimo uburyo bwo gutegura na nyuma yo gusasura.
              By'umwihariko, inguzanyo izakoreshwa mu buhinzi bw'{translated_loan_purpose}.`,
      },
    },
    {
      type: "expression",
      name: "translated_loan_purpose",
      expression: "translateLoanPurpose({loan_purpose})",
      visible: false
    },
  ],
}

const use_of_loan_irrigation_system = {
  name: "use_of_loan_irrigation_system",
  type: "panel",
  title: {
    en: "Use of the Loan",
    rw: "Imikoreshereze y’ Inguzanyo",
  },
  elements: [
      {
          type: "html",
          html: {
              en: `The Borrower will utilize the borrowed funds exclusively for the acquisition of an irrigation system.`,
              rw: `Uwagurijwe azakoresha amafaranga yagurijwe mu kugura uburyo bwo kuhira imyaka gusa.`,
          }
      }
  ],
}


// This is used by all crops except Tea
const late_payment = {
  name: "late_payment",
  type: "panel",
  title: {
    en: "Late Payment",
    rw: "Gutinda kwishyura",
  },
  elements: [
    {
      type: "html",
      html: {
        en: `The borrower acknowledges and commits to ensuring timely payments, demonstrating
              their dedication. In the event of late payment, a charge of {late_fee_per_month}% RWF will be applied for
              each month the payment is overdue.`,
        rw: `Ugurizwa aremera kandi yiyemeza kwishyura ku gihe, agaragaza ubwitange bwe. Mu gihe yatinze
              kwishyura inguzanyo, azacibwa amafaranga angana na {late_fee_per_month}% ya RWF buri kwezi yakereweho kwishyura
              nkigihano cyuwatinze kwishyura inguzanyo.`,
      },
    },
  ],
}

const payment_methods = {
  name: "payment_methods",
  type: "panel",
  title: {
    en: "Payment Methods",
    rw: "Uburyo bwo kwishyura",
  },
  elements: [
    {
      type: "html",
      html: {
        en: `<p>
              You can pay the loan with one of the following methods:
            </p>
            <ul>
              <li>
                MTN wallet
                <ul>
                  <li>
                    Momo pay code: 987825
                  </li>
                </ul>
              </li>
              <li>
                I&M Bank Account
                <ul>
                  <li>
                    20046413005
                  </li>
                </ul>
              </li>
            </ul>`,
        rw: `<p>
              Ushobora kwishyura inguzanyo ushoresheje bumwe muburyo bukurikira:
            </p>
            <ul>
              <li>
                MTN wallet
                <ul>
                  <li>
                    Momo pay code: 987825
                  </li>
                </ul>
              </li>
              <li>
                I&M Bank Account
                <ul>
                  <li>
                    20046413005
                  </li>
                </ul>
              </li>
            </ul>`
      }
    }
  ]
}

const law = {
  name: "law",
  type: "panel",
  title: {
    en: "Law",
    rw: "Amategeko",
  },
  elements: [
    {
      type: "html",
      html: {
        en: `The Borrower acknowledges and consents that the Lender, in accordance with Law Law No. 73/2018 dated 31/08/2018 Article 4, 
        is authorized to collect, maintain, and transmit accurate information relating to this loan to credit reporting service providers in accordance with 
        applicable Rwandan law and regulatory requirements.`,
        rw: `Uwagurijwe yemereye kandi yemeye ko Uwatanze inguzanyo, hakurikije Itegeko No 73/2018 ryo ku wa 31/08/2018 Ingingo ya 4, yemerewe gukusanya, kubungabunga,
         no kohereza no gutanga amakuru nyayo ajyanye n'iyi nguzanyo ku batanga serivisi z’inguzanyo hakurikijwe amategeko cyangwa n’andi mabwiriza yose akoreshwa mu Rwanda. `,
      },
    },
    {
        type: "html",
        visibleIf: "{loan_purpose} != 'coffee' and {loan_purpose} != 'tea' and {loan_purpose} != 'fish' and {loan_purpose} != 'tomato' and {loan_purpose} != 'onion' and {loan_purpose} != 'avocado' and {loan_purpose} != 'passion_fruit' and {loan_type} != 'group'",
        html: {
            en: "This loan is made possible by MoneyPhone Africa Ltd. and BRD under the CDAT project.",
            rw: "Iyi nguzanyo ikozwe bishobokeshijwe na MoneyPhone Africa Ltd. na BRD mu mushinga wa CDAT.",
        },
    },
    {
      type: "html",
      visibleIf: "{loan_purpose}=='fish' || {loan_purpose}=='tomato' || {loan_purpose}=='onion' || {loan_purpose}=='avocado' || {loan_purpose}=='passion_fruit'",
      html: {
          en: "This loan benefits from an 8 percent interest rate subsidy under the Kwihaza Facility managed by AFR. The borrower pays only the net interest rate stated in this contract; the subsidy is settled directly between AFR and MoneyPhone.",
          rw: "Iyi nguzanyo ihabwa inkunga ya 8% akishyura inyungu biciye muri Kwihaza Facility iyobowe na AFR. Uwagujije yishyura inyungu nto yavuzwe muri aya masezerano; iyo nkunga yishyurwa hagati ya AFR na MoneyPhone.",
      },
    },
  ],
}

const sign = {
  name: "sign",
  type: "panel",
  title: {
    en: "Signature",
    rw: "Usaba Inguzanyo",
  },
  elements: [
    {
      name: "sign_name",
      type: "text",
      isRequired: true,
      title: {
        en: "Your full name",
        rw: "Amazina yombi ",
      },
    },
    {
      title: { en: "Sign", rw: "Umukono" },
      type: "signaturepad",
      isRequired: true,
      name: "signature",
    },
  ],
}


const repayment_terms = [
  {
    type: "html",
    visibleIf: "{repayment_period} != 12",
    html: {
      en: `The borrower agrees to repay the full loan amount 
            within {repayment_period} months from the date the loan is received. 
            All payments must be made before the final repayment date.
            <br><br>
            Repayment method: 
            The borrower will repay the entire loan amount in a single payment before the end of the {repayment_period}-month repayment period.`,
      rw: `Usaba inguzanyo yemera kwishyura inguzanyo yose uko ingana mu gihe cy'amezi {repayment_period} 
           kuva kw'itariki aboneyeho iyo nguzanyo.
           Ubwishyu bwose bugomba kuba bwakozwe mbere y'itariki ya nyuma yo kwishyuraho.
           Uburyo bwo kwishyura: Uwagujije azishyurira rimwe inguzanyo ye yose mbere y'igihe cy'amezi {repayment_period} cyo kuba yishyuye.`,
    },
  },
  {
    type: "html",
    visibleIf: "{repayment_period} == 12",
    html: {
      en: `The borrower commits to repay {monthly_installment} RWF, half the amount of the loan and interest within 6 months from the date of signing {today_date} and 
            {monthly_installment} RWF, the other half of the loan and interest within 12 months of signing. The complete amount should be repaid 
            before {repayment_date}.`,
      rw: `Niyemeje kwishyura {monthly_installment} RWF, kimwe cyakabiri cy'inguzanyo n'inyungu mu mezi atandatu guhera {today_date} na {monthly_installment} RWF,
            ikindi gice cy'inguzanyo n'inyungu mu mezi 12 . Amafaranga yose azishyurwa mbere {repayment_date}.`,
    },
  },
]

export const sign_rwanda_direct_model_chili = {
  showProgressBar: "top",
  showQuestionNumbers: "off",
  sendResultOnPageNext: true,
  firstPageIsStarted: false,
  showCompletedPage: false,
  completeText: {
    en: "Submit loan application",
    rw: "Ohereza",
  },
  questionStartIndex: 1,
  requiredText: "",
  pages: [
    // Page 1: Terms and conditions
    terms_and_conditions,
    // Page 2: Loan Agreement
    {
      title: {
        en: "Loan Agreement",
        rw: "Amasezerano y'inguzanyo",
      },
      name: "review",
      innerIndent: 1,
      elements: [
        date,
        total_overview,
        loan_terms,
        guarantee,
        {
          name: "payment",
          type: "panel",
          title: {
            en: "Payment",
            rw: "Ubwishyu",
          },
          elements: [
            {
              type: "html",
              html: {
                en: `The borrower authorizes the cooperative to automatically deduct the amount corresponding to the loan
                      repayment directly from the production income.`,
                rw: `Ugurizwa aha uburenganzira koperative guhita itangira byihuse kwishyura
                      inguzanyo ikuramo amafaranga biturutse ku nyungu iva k'umusaruro.`
              }
            },
            ...repayment_terms,
          ],
        },
        mobile_wallet_payments,
        use_of_loan,
        late_payment,
        payment_methods,
        law,
        sign,
      ],
    },
  ],
};

export const sign_rwanda_direct_model_default = {
  showProgressBar: "top",
  showQuestionNumbers: "off",
  sendResultOnPageNext: true,
  firstPageIsStarted: false,
  showCompletedPage: false,
  completeText: {
    en: "Submit loan application",
    rw: "Ohereza",
  },
  questionStartIndex: 1,
  requiredText: "",
  pages: [
    // Page 1: Terms and conditions
    terms_and_conditions,
    // Page 2: Loan Agreement
    {
      title: {
        en: "Loan Agreement",
        rw: "Amasezerano y'inguzanyo",
      },
      name: "review",
      innerIndent: 1,

      elements: [
        date,
        {
          type: "expression",
          name: "repayment_date",
          expression: "monthsFromNow({repayment_period}, 0, 'rw')",
          title: "Repayment date created to be called in the html section",
          visibleIf: "false"
        },
        total_overview,
        loan_terms,
        guarantee,
        {
          name: "payment",
          type: "panel",
          title: {
            en: "Payment",
            rw: "Ubwishyu",
          },
          elements: repayment_terms,
        },
        mobile_wallet_payments,
        use_of_loan,
        late_payment,
        payment_methods,
        law,
        sign,
      ],
    },
  ],
};

export const sign_rwanda_direct_model_monthly_payment = {
  showProgressBar: "top",
  showQuestionNumbers: "off",
  sendResultOnPageNext: true,
  firstPageIsStarted: false,
  showCompletedPage: false,
  completeText: {
    en: "Submit loan application",
    rw: "Ohereza",
  },
  questionStartIndex: 1,
  requiredText: "",
  pages: [
    // Page 1: Terms and conditions
    terms_and_conditions,
    // Page 2: Loan Agreement
    {
      title: {
        en: "Loan Agreement",
        rw: "Amasezerano y'inguzanyo",
      },
      name: "review",
      innerIndent: 1,

      elements: [
        date,
        total_overview,
        {
          name: "loan_terms_panel",
          type: "panel",
          title: {
            en: "Loan Terms",
            rw: "Ingingo zigize aya masezerano y'inguzanyo",
          },
          description: {
            en: "The borrower is committing to pay the lender the amount borrowed in accordance with the following:",
            rw: "Ugurizwa yiyemeje kwishyura uwamugurije umwenda akurikije ibi bikurikira:",
          },
          visibleIf: "{amount} notempty and {repayment_period} notempty",
          elements: [
            {
              name: "loan_terms",
              valueName: "loan_terms",
              type: "expression",
              expression:
                "loan_terms", // Floating Point Proof
              title: "Technical loan terms (NOT visible for user)",
              visibleIf: "{amount} < 0",
            },
            {
              title: {
                en: "Requested loan amount in RWF",
                rw: "Amafaranga y'inguzanyo asabwa",
              },
              type: "expression",
              expression: "{requested_amount}",
            },
            {
              title: {
                en: "Approved loan amount in RWF",
                rw: "Amafaranga y'inguzanyo yemejwe",
              },
              type: "expression",
              expression: "{amount}", // Floating Point Proof
            },
            {
              title: {
                en: "Loan term (in months)",
                rw: "Igihe inguzanyo izamara (Mu mezi)",
              },
              name: "repayment_period",
              type: "expression",
              expression: "{repayment_period}", // Floating Point Proof
            },
            {
              title: {
                en: "Total administrative fees in RWF to be deducted from the loan amount ({admin_fee})",
                rw: "Amafaranga ya serivise y'ubuyobozi angana na {admin_fee} akurwa kunguzanyo yemejwe",
              },
              type: "expression",
              expression: "{charge_dict.charge_code_1.total}", // Floating Point Proof
            },
            {
              title: {
                en: "Total VAT on administrative fees in RWF to be deducted from the loan amount ({vat_on_admin_fee})",
                rw: "Umusoro(VAT) ukurwa kunguzanyo yemejwe ({vat_on_admin_fee})",
              },
              type: "expression",
              expression: "{charge_dict.charge_code_2.total}", // Floating Point Proof
            },
            {
              title: {
                en: "Insurance fees in RWF to be deducted from the loan amount ({insurance_fee}) ",
                rw: "Amafaranga y'ubwishingizi akurwa kunguzanyo yemejwe ({insurance_fee})",
              },
              type: "expression",
              expression: "{charge_dict.charge_code_3.total}", // Floating Point Proof
            },
            {
              title: {
                en: "Loan interest in RWF ({product_interest_rate}% per year)",
                rw: "Inyungu ku ngunzanyo mu mwaka mu RWF ({product_interest_rate}% ku mwaka)",
              },
              name: "custom_float_5",
              type: "expression",
              expression: "{total_interest}", // Floating Point Proof
            },
            {
              title: {
                en: "Total loan amount to be disbursed: approved loan amount minus fees",
                rw: "Igiteranyo cy'Amafaranga yinguzanyo yemejwe gutangwa",
              },
              name: "custom_float_6",
              type: "expression",
              expression: "fixed(subtract({amount},{charge_dict.charge_code_1.total},{charge_dict.charge_code_2.total},{charge_dict.charge_code_3.total})", // Floating Point Proof
            },
            {
              title: {
                en: "Total loan amount to be repaid: approved loan amount plus interest",
                rw: "Igiteranyo cy' Amafaranga yinguzanyo yemejwe gusubizwa",
              },
              name: "custom_float_7",
              type: "expression",
              expression: "fixed(add({amount}, {total_interest}))", // Floating Point Proof
            },
            {
              title: {
                en: "Annual Percentage Rate (APR) %",
                rw: "Ijanisha ry'inguzanyo ku mwaka %",
              },
              type: "expression",
              expression: "fixed({annual_percentage_rate}", // Floating Point Proof
            },
            {
              title: {
                en: "Monthly amount",
                rw: "Ubwishyu bwa buri kwezi",
              },
              name: "custom_float_8",
              type: "expression",
              expression: "fixed(divide({custom_float_7}, {repayment_period}))",
            },
            {
              title: {
                en: "Cooking Stove",
                rw: "Imbabura ya kijyambere"
              },
              name: "cooking_stove_amount",
              type: "expression",
              visibleIf: "{intake.custom_bool_3} = true",
              expression: "{intake.cooking_stove_amount}"
            },
            {
              visibleIf: "{intake.custom_bool_3} = true",
              type: "panel",
              title: {
                en: "Cooking Stove",
                rw: "Imbabura ya kijyambere",
              },
              elements: [
                {
                  type: "html",
                  html: {
                    en: `By selecting the option to include a cooking stove in the loan application, an amount of RWF {cooking_stove_amount} will be deducted from the amount disbursed allocated for the cooking stove. The farmer acknowledges that this amount is non-refundable and will be directly allocated for the purchase of the cooking stove as part of the loan agreement.`,
                    rw: `Mu guhitamo uburyo bwo guhabwa imbabura ya kijyambere mu busabe bw'inguzanyo, igiciro cya {cooking_stove_amount}rwf kirakurwa ku mafaranga y'inguzanyo agenerwe imbabura ya kijyambere . Umuhinzi aremeza ko aya mafaranga adasubizwa kandi ko azaba ajyenewe mu kugura imbabura ya kijyambere nka kimwe mu bikubiye mu masezerano y'inguzanyo.`,
                  },
                },
              ],
            },

          ],
        },
        guarantee,
        {
          name: "payment",
          type: "panel",
          title: {
            en: "Payment",
            rw: "Ubwishyu",
          },
          elements: [
            {
              type: "html",
              html: {
                en: `The borrower authorizes the cooperative to automatically deduct the amount corresponding to the monthly loan
                      repayment directly from the production income.`,
                rw: `Uwagurijwe yemerera koperative guhita ikuramo amafaranga ahwanye no kwishyura inguzanyo ya buri kwezi bivuye
                      mu musaruro.`
              }
            },
            {
              type: "html",
              visibleIf: "{loan_purpose} == 'tea'",
              html: {
                en: `The borrower agrees to repay the total loan amount in full 
                      within six months from the date of signing this agreement. 
                      All repayments must be completed before the stipulated repayment deadline.
                      <br><br>
                      Payment Schedule: 
                      The borrower shall make a lump-sum (bullet) payment of the outstanding loan amount before the end of the 6-month loan term.`,
                rw: `Usaba inguzanyo yemera kwishyura inguzanyo yose uko ingana mu gihe cy'amezi atandatu 
                     kuva itariki asinyiyeho aya masezerano. 
                     Ubwishyu bwose bugomba kuba bwakozwe mbere y'itariki ya nyuma yo kwishyuraho.
                     Uburyo bwo kwishyura: Uwagujije azishyurira rimwe inguzanyo ye yose mbere y'igihe cy'amezi 6 cyo kuba yishyuye.`,
              }
            },  
            {
              ...repayment_terms[0],
              visibleIf: "{loan_purpose} == 'fish'",
            },
            {
              type: "html",
              html: {
                en: `MoneyPhone will receive monthly payments in the amount of {custom_float_8}. The borrower is aware that
                      she/he will have to repay the full loan amount of {amount} RWF plus {custom_float_5} RWF for expenses.`,
                rw: `MoneyPhone izajya yakira ubwishyu  buri kwezi bungana na {custom_float_8}.
                      Uwagurijwe azi neza ko agomba kwishyura amafaranga yinguzanyo yuzuye
                      {amount} RWF wongeyeho {custom_float_5} RWF y'ibyakoreshejwe(depense).`
              }
            }
          ]
        },
        mobile_wallet_payments,
        use_of_loan,
        late_payment,
        payment_methods,
        law,
        sign,
      ],
    },
  ],
};

export const sign_irrigation_system = {
    showProgressBar: "top",
    showQuestionNumbers: "off",
    sendResultOnPageNext: true,
    firstPageIsStarted: false,
    showCompletedPage: false,
    completeText: {
        en: "Submit loan application",
        rw: "Ohereza",
    },
    questionStartIndex: 1,
    requiredText: "",
    pages: [
        // Page 1: Terms and conditions
        terms_and_conditions,
        // Page 2: Loan Agreement
        {
            title: {
                en: "Loan Agreement",
                rw: "Amasezerano y'inguzanyo",
            },
            name: "review",
            innerIndent: 1,

            elements: [
                date,
                {
                    type: "expression",
                    name: "repayment_date",
                    expression: "monthsFromNow({repayment_period}, 0, 'rw')",
                    title: "Repayment date created to be called in the html section",
                    visibleIf: "false"
                },
                total_overview,
                loan_terms,
                guarantee_irrigation_system,
                {
                    name: "payment",
                    type: "panel",
                    title: {
                        en: "Payment",
                        rw: "Ubwishyu",
                    },
                    elements: [
                        ...repayment_terms,
                    ],
                },
                mobile_wallet_payments,
                use_of_loan_irrigation_system,
                late_payment,
                payment_methods,
                law,
                sign,
            ],
        },
    ],
};
